import React, { useEffect } from 'react';
import './styles/App.css';
import './styles/motion.css';
import './styles/apple.css';
import AppRouter from './navigation/AppRouter';
import { loadVendorScripts } from './utils/loadVendorScripts';
import { setupGsap } from './motion/gsapSetup';

function App() {
  useEffect(() => {
    document.body.classList.add('apple-site');
    setupGsap();
    loadVendorScripts();
    return () => document.body.classList.remove('apple-site');
  }, []);

  return <AppRouter />;
}

export default App;
